var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"notification-kind-badge",class:_vm.modifierClass,attrs:{"data-testid":_vm.dataTestid}},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }